import propTypes from 'prop-types';
import { Input, Label } from '@kiper/ui';

const TextAreaField = ({ name, label, value, onChange }) => (
  <div>
    <Label htmlFor={name}>{label}</Label>
    <Input
      type="textarea"
      name={name}
      rows={3}
      value={value}
      onChange={onChange}
    />
  </div>
);

TextAreaField.propTypes = {
  name: propTypes.string.isRequired,
  label: propTypes.string.isRequired,
  value: propTypes.string,
  onChange: propTypes.func.isRequired,
};

TextAreaField.defaultProps = {
  value: '',
};

export default TextAreaField;
